import { render, staticRenderFns } from "./ControlBar.vue?vue&type=template&id=23f0ddba&scoped=true&"
import script from "./ControlBar.vue?vue&type=script&lang=ts&"
export * from "./ControlBar.vue?vue&type=script&lang=ts&"
import style0 from "./ControlBar.vue?vue&type=style&index=0&id=23f0ddba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f0ddba",
  null
  
)

export default component.exports